/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOverride = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h4v2H4v2H2V2zm10 2H8V2h4v2zm4 0h-2V2h4v4h-2V4zM4 8v4H2V8h2zm4 0h14v14H8V8zm2 2v10h10V10H10zm-6 6v-2H2v4h4v-2H4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOverride as Override };
